const mixinCalculateExtraHourWeek = {
  methods: {
    handleCellStyle({ row }) {
      const isHeaderRow = 'farm_id' in row && 'worker_id' in row && 'date' in row;
    
      if (isHeaderRow) {
        const extraWeekHours = this.getExtraWeekHours(row);

        if (
          Number(row.exceeds_daily_limit) > 12 
          || row.is_duplicate
          || row.extra_day_hours && Number(row.extra_day_hours) > 4
          || Number(extraWeekHours) > 12
        ) {
          return 'background-color: #fde6e4;';
        }
      } else {
        const data = this.tableDataDetails.filter((item) => item.id !== row.id);
        const isDuplicate = data.some((item) => {
          const condition = `${item.quantity} ${item.activity_id} ${
            item.number_hours
          } ${item.lot_id ? item.lot_id : ''}`;
          const toEvaluate = `${row.quantity} ${row.activity_id} ${
            row.number_hours
          } ${row.lot_id ? row.lot_id : ''}`;
    
          return condition === toEvaluate;
        });
    
        if (!row.subtotal || isDuplicate) {
          return 'background-color: #fde6e4;';
        }
      }
    
      return '';
    }
  },
};

export default mixinCalculateExtraHourWeek;
